import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcb8d8c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AiConfiguratorShop" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "AiConfiguratorShopModal__dialog",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Konfigurator AI"
}
const _hoisted_4 = { class: "AiConfiguratorShopModal__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "AiConfiguratorShopModal__eyebrow" }, "Konfigurator AI"),
  /*#__PURE__*/_createElementVNode("h3", { class: "AiConfiguratorShopModal__title font-soligant h4" }, " Sprawdź, co AI wybierze dla Ciebie "),
  /*#__PURE__*/_createElementVNode("p", null, " Odpowiedz na 10 szybkich pytań o to, jak chcesz się czuć, na jaką okazję szukasz i co lubisz. Nasz algorytm przeanalizuje setki produktów w kilka sekund i pokaże Ci tylko te, które naprawdę do Ciebie pasują. ")
], -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "AiConfiguratorShopModal__state"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ładuję konfigurator...", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "AiConfiguratorShopModal__body"
}
const _hoisted_11 = { class: "AiConfiguratorShopModal__progressWrap" }
const _hoisted_12 = { class: "AiConfiguratorShopModal__progressTrack" }
const _hoisted_13 = { class: "AiConfiguratorShopModal__progressLabel" }
const _hoisted_14 = { class: "AiConfiguratorShopModal__question h4 font-soligant" }
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "AiConfiguratorShopModal__error"
}
const _hoisted_18 = { class: "AiConfiguratorShopModal__actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "AiConfiguratorShopModal__state"
}

import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { applyConfiguratorToShop, fetchConfiguratorSchema, fetchConfiguratorState } from './api';


export default {
  __name: 'AiConfiguratorShopPopup',
  setup(__props) {

const isOpen = ref(false);
const isLoadingSchema = ref(false);
const isSubmitting = ref(false);
const errorMessage = ref('');
const schema = ref(null);
const stepIndex = ref(0);
const answers = reactive({});
const savedState = ref(null);
let schemaRequest = null;
let stateRequest = null;

const steps = computed(() => {
    if (!schema.value || !Array.isArray(schema.value.steps)) {
        return [];
    }

    return schema.value.steps;
});

const currentStep = computed(() => steps.value[stepIndex.value] || null);
const currentStepLabel = computed(() => {
    if (!currentStep.value) {
        return '';
    }

    return `Krok ${stepIndex.value + 1} z ${steps.value.length}`;
});

const progress = computed(() => {
    if (!steps.value.length) {
        return 0;
    }

    return Math.round(((stepIndex.value + 1) / steps.value.length) * 100);
});

const canGoBack = computed(() => stepIndex.value > 0);
const isLastStep = computed(() => stepIndex.value === steps.value.length - 1);
const canGoForward = computed(() => {
    if (!currentStep.value) {
        return false;
    }

    if (!currentStep.value.required) {
        return true;
    }

    const selected = answers[currentStep.value.id];
    if (currentStep.value.type === 'multi') {
        return Array.isArray(selected) && selected.length > 0;
    }

    return typeof selected === 'string' && selected.length > 0;
});

function isOptionSelected(step, optionId) {
    const selected = answers[step.id];
    if (step.type === 'multi') {
        return Array.isArray(selected) && selected.includes(optionId);
    }

    return selected === optionId;
}

function onOptionClick(step, option) {
    if (!step || !option || isSubmitting.value) {
        return;
    }

    if (step.type === 'multi') {
        const current = Array.isArray(answers[step.id]) ? [...answers[step.id]] : [];
        const neutralOptionIds = (step.options || [])
            .filter((item) => item?.neutral)
            .map((item) => item.id);

        if (option.neutral) {
            answers[step.id] = [option.id];
            return;
        }

        const withoutNeutral = current.filter((id) => !neutralOptionIds.includes(id));
        if (withoutNeutral.includes(option.id)) {
            const updated = withoutNeutral.filter((id) => id !== option.id);
            if (updated.length) {
                answers[step.id] = updated;
            } else {
                delete answers[step.id];
            }

            return;
        }

        answers[step.id] = [...withoutNeutral, option.id];
        return;
    }

    answers[step.id] = option.id;
}

function resetWizard() {
    Object.keys(answers).forEach((key) => delete answers[key]);
    stepIndex.value = 0;
    errorMessage.value = '';
}

function getAiTokenFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get('aiq') || '';
    } catch (error) {
        return '';
    }
}

async function ensureSavedState({ silent = true } = {}) {
    const token = getAiTokenFromUrl();
    if (!token) {
        savedState.value = null;
        return null;
    }

    if (savedState.value && savedState.value.token === token) {
        return savedState.value;
    }

    if (stateRequest) {
        return stateRequest;
    }

    stateRequest = (async () => {
        try {
            const data = await fetchConfiguratorState(token);
            savedState.value = data && typeof data === 'object' ? data : null;
            return savedState.value;
        } catch (error) {
            if (!silent) {
                errorMessage.value =
                    error?.message || 'Nie udało się pobrać zapisanego stanu konfiguratora.';
            }
            return null;
        } finally {
            stateRequest = null;
        }
    })();

    return stateRequest;
}

function applySavedAnswersToWizard(rawAnswers) {
    if (!rawAnswers || typeof rawAnswers !== 'object' || !steps.value.length) {
        return;
    }

    Object.keys(answers).forEach((key) => delete answers[key]);

    steps.value.forEach((step) => {
        if (!step?.id) {
            return;
        }

        const rawValue = rawAnswers[step.id];
        if (rawValue === undefined || rawValue === null) {
            return;
        }

        const allowedOptionIds = new Set(
            (step.options || []).map((option) => String(option?.id || '')),
        );
        if (step.type === 'multi') {
            if (!Array.isArray(rawValue)) {
                return;
            }

            const cleaned = rawValue
                .map((item) => String(item))
                .filter((item) => allowedOptionIds.has(item));
            const uniqueValues = [...new Set(cleaned)];
            if (uniqueValues.length > 0) {
                answers[step.id] = uniqueValues;
            }
            return;
        }

        const normalizedValue = String(rawValue);
        if (allowedOptionIds.has(normalizedValue)) {
            answers[step.id] = normalizedValue;
        }
    });

    const firstMissingRequired = steps.value.findIndex((step) => {
        if (!step?.required) {
            return false;
        }

        const selected = answers[step.id];
        if (step.type === 'multi') {
            return !Array.isArray(selected) || selected.length === 0;
        }

        return typeof selected !== 'string' || selected.length === 0;
    });

    stepIndex.value = firstMissingRequired >= 0 ? firstMissingRequired : 0;
}

async function ensureSchema({ silent = false } = {}) {
    if (schema.value && Array.isArray(schema.value.steps)) {
        return true;
    }

    if (schemaRequest) {
        return schemaRequest;
    }

    isLoadingSchema.value = true;
    if (!silent) {
        errorMessage.value = '';
    }

    schemaRequest = (async () => {
        try {
            const loadedSchema = await fetchConfiguratorSchema();
            if (!loadedSchema || !Array.isArray(loadedSchema.steps)) {
                throw new Error('Nie udało się załadować konfiguratora AI.');
            }

            schema.value = loadedSchema;
            return true;
        } catch (error) {
            if (!silent) {
                errorMessage.value = error?.message || 'Nie udało się załadować konfiguratora AI.';
            }
            return false;
        } finally {
            isLoadingSchema.value = false;
            schemaRequest = null;
        }
    })();

    return schemaRequest;
}

async function openModal() {
    resetWizard();
    isOpen.value = true;

    const [schemaLoaded, state] = await Promise.all([ensureSchema(), ensureSavedState()]);

    if (!schemaLoaded) {
        return;
    }

    const savedAnswers = state && typeof state === 'object' ? state.answers : null;
    if (savedAnswers && typeof savedAnswers === 'object') {
        applySavedAnswersToWizard(savedAnswers);
    }
}

function closeModal() {
    if (isSubmitting.value) {
        return;
    }

    isOpen.value = false;
}

function goBack() {
    if (!canGoBack.value || isSubmitting.value) {
        return;
    }

    stepIndex.value -= 1;
}

async function goNext() {
    if (!canGoForward.value || isSubmitting.value) {
        return;
    }

    if (isLastStep.value) {
        await submitWizard();
        return;
    }

    stepIndex.value += 1;
}

async function submitWizard() {
    if (isSubmitting.value) {
        return;
    }

    isSubmitting.value = true;
    errorMessage.value = '';

    try {
        const defaults = schema.value?.defaults || {};
        const configuredTopN = Number(defaults.top_n);
        const payload = {
            answers: JSON.parse(JSON.stringify(answers)),
            top_n:
                Number.isFinite(configuredTopN) && configuredTopN > 0
                    ? Math.max(configuredTopN, 24)
                    : 24,
            min_score: Number(defaults.min_score) > 0 ? Number(defaults.min_score) : 25,
            current_url: window.location.href,
        };

        const data = await applyConfiguratorToShop(payload);
        const redirectUrl = String(data?.redirect_url || '');
        if (!redirectUrl) {
            throw new Error('Nie udało się zastosować wyników konfiguratora.');
        }

        window.location.assign(redirectUrl);
    } catch (error) {
        errorMessage.value = error?.message || 'Nie udało się zastosować wyników konfiguratora.';
        isSubmitting.value = false;
    }
}

function prefetchConfiguratorData() {
    void ensureSchema({ silent: true });
    void ensureSavedState({ silent: true });
}

function onKeydown(event) {
    if (event.key === 'Escape' && isOpen.value) {
        closeModal();
    }
}

watch(isOpen, (open) => {
    document.body.style.overflow = open ? 'hidden' : '';
});

onMounted(() => {
    window.addEventListener('keydown', onKeydown);
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => {
            prefetchConfiguratorData();
        });
        return;
    }

    window.setTimeout(() => {
        prefetchConfiguratorData();
    }, 250);
});

onBeforeUnmount(() => {
    window.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = '';
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "AiConfiguratorShop__trigger Button Button--secondary",
      onClick: openModal,
      onMouseenter: prefetchConfiguratorData,
      onFocus: prefetchConfiguratorData,
      onTouchstartPassive: prefetchConfiguratorData
    }, " Konfigurator AI ", 32),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "ai-shop-modal" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "AiConfiguratorShopModal",
                onClick: _withModifiers(closeModal, ["self"])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("header", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("button", {
                      type: "button",
                      class: "Button--no-style AiConfiguratorShopModal__close",
                      disabled: isSubmitting.value,
                      onClick: closeModal
                    }, " Zamknij ", 8, _hoisted_6)
                  ]),
                  (isLoadingSchema.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : (_unref(currentStep))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", {
                                class: "AiConfiguratorShopModal__progressFill",
                                style: _normalizeStyle({ width: `${_unref(progress)}%` })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(currentStepLabel)), 1)
                          ]),
                          _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(currentStep).question), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["AiConfiguratorShopModal__options", { 'is-multi': _unref(currentStep).type === 'multi' }])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentStep).options, (option) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: option.id,
                                type: "button",
                                class: _normalizeClass(["Button--no-style AiConfiguratorShopModal__option", {
                                        'is-selected': isOptionSelected(_unref(currentStep), option.id),
                                    }]),
                                disabled: isSubmitting.value,
                                onClick: $event => (onOptionClick(_unref(currentStep), option))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(option.label), 1),
                                (_unref(currentStep).type === 'multi')
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(isOptionSelected(_unref(currentStep), option.id)
                                            ? 'Wybrane'
                                            : 'Wybierz'), 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_15))
                            }), 128))
                          ], 2),
                          (errorMessage.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errorMessage.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("footer", _hoisted_18, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "Button--no-style AiConfiguratorShopModal__btn AiConfiguratorShopModal__btn--ghost",
                              disabled: !_unref(canGoBack) || isSubmitting.value,
                              onClick: goBack
                            }, " Wstecz ", 8, _hoisted_19),
                            _createElementVNode("button", {
                              type: "button",
                              class: "Button--no-style AiConfiguratorShopModal__btn AiConfiguratorShopModal__btn--primary",
                              disabled: !_unref(canGoForward) || isSubmitting.value,
                              onClick: goNext
                            }, _toDisplayString(isSubmitting.value
                                            ? 'Dobieram produkty...'
                                            : _unref(isLastStep)
                                            ? 'Pokaż produkty w sklepie'
                                            : 'Dalej'), 9, _hoisted_20)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("p", null, _toDisplayString(errorMessage.value || 'Nie udało się załadować konfiguratora.'), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "Button--no-style AiConfiguratorShopModal__retry",
                            onClick: _cache[0] || (_cache[0] = $event => (ensureSchema()))
                          }, " Spróbuj ponownie ")
                        ]))
                ])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

}